module.exports = __webpack_public_path__ + "static/img/logo-shield-gray-club.34bbea5.png";